import environment from './environment';

const API_CONFIG = {
    development: {
        BASE_URL: 'http://192.168.1.36:5300'
    },
    production: {
        BASE_URL: 'https://triel.ovh'
    }
};

const API_ENDPOINTS = {
    LOGIN: '/api/login',
    PRODUCTEURS: '/api/producteurs',
    MATIERES: '/api/matieres'
};

const getApiConfig = () => {
    const env = process.env.NODE_ENV || 'development';
    return {
        ...API_CONFIG[env],
        ENDPOINTS: API_ENDPOINTS
    };
};

const config = getApiConfig();
export const { BASE_URL, ENDPOINTS } = config;

export default API_CONFIG; 